import { EN_LANGUAGE } from "@/shared/i18n/en-language";

/**
 * Extracts the language code from a locale string.
 * @param locale - Full locale code (e.g., "de-DE", "en-US")
 * @returns Language code (e.g., "de", "en")
 */
export const getLanguageFromLocale = (locale: string): string => {
    const [language] = locale.split("-");
    return language || EN_LANGUAGE;
};
